export class LoginInfo {
  accessToken: string;
  private tokenType: string;
  private expiresIn: number;
  private refreshToken: string;
  private userId: string;
  private userName: string;

  setAccessToken(value: string): void {
    this.accessToken = value;
  }

  getAccessToken(): string {
    return this.accessToken;
  }

  setTokenType(value: string): void {
    this.tokenType = value;
  }

  getTokenType(): string {
    return this.tokenType;
  }

  setExpiresIn(value: number): void {
    this.expiresIn = value;
  }

  getExpiresIn(): number {
    return this.expiresIn;
  }

  setRefreshToken(value: string): void {
    this.refreshToken = value;
  }

  getRefreshToken(): string {
    return this.refreshToken;
  }

  setUserId(value: string): void {
    this.userId = value;
  }

  getUserId(): string {
    return this.userId;
  }

  setuserName(value: string): void {
    this.userName = value;
  }

  getuserName(): string {
    return this.userName;
  }

  toString() {
    return this;
  }
}
